import { createStandaloneToast, CreateStandaloneToastReturn } from '@chakra-ui/react';

import theme from '@/theme';

const standaloneToast = createStandaloneToast({
  theme,
  defaultOptions: { isClosable: true, duration: 3000 },
});

export const ToastContainer = standaloneToast.ToastContainer;
export const toast: CreateStandaloneToastReturn['toast'] = standaloneToast.toast;
